import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useAppRightPanelStore = defineStore('app-right-panel', () => {
    const sectionPartials = ref<string[]>([]);

    function addPartials(partials: string[] | string) {
        if (typeof partials === 'string') partials = [partials];
        sectionPartials.value = [...sectionPartials.value, ...partials];
    }

    return { sectionPartials, addPartials };
});

export function addAppRightBarPartials(...partials: string[]) {
    const store = useAppRightPanelStore();
    store.addPartials(partials);
}
